/**
 * Archive-property template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";
import Logger from "./lib/logger";
import PropertyMap from "./lib/partials/PropertyMap";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Archive-property";

let currentPaginationPage = 1;

const loadMoreButtonDom = document.querySelector(`[data-load-more-button]`);

const propertyGridDom = document.querySelector(`[data-property-grid]`);

const propertyMapDom = document.querySelector(`[data-property-map]`);

const filterDrawerDom = document.querySelector(`[data-filter-drawer]`);
const filterDrawerToggleButtonDoms = document.querySelectorAll(
	`[data-filter-drawer-toggle]`
);
const sortDrawerDom = document.querySelector(`[data-sort-drawer]`);
const sortDrawerToggleButtonDoms = document.querySelectorAll(
	`[data-sort-drawer-toggle]`
);
const filterDrawerActiveClass = `property-hero__filter-drawer--active`;
const sortDrawerActiveClass = `property-hero__sort-drawer--active`;

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initFilterDrawerToggles();
	initSortDrawerToggles();
	initLoadMoreButton();
	initMap();
};

/**
 * initFilterDrawerToggles - Initialize the filter drawer
 */
const initFilterDrawerToggles = () => {
	Logger.info(`${NAME} > initFilterDrawerToggles`);

	if (!filterDrawerToggleButtonDoms) return;

	filterDrawerToggleButtonDoms.forEach((button) => {
		button.addEventListener("click", (event) => {
			event.preventDefault();
			toggleFilterDrawer();
		});
	});
};

/**
 * initSortDrawerToggles - Initialize the sort drawer
 */
const initSortDrawerToggles = () => {
	Logger.info(`${NAME} > initSortDrawerToggles`);

	if (!sortDrawerToggleButtonDoms) return;

	sortDrawerToggleButtonDoms.forEach((button) => {
		button.addEventListener("click", (event) => {
			event.preventDefault();
			toggleSortDrawer();
		});
	});
};

/**
 * initLoadMoreButton - Initialize the load more button
 */
const initLoadMoreButton = () => {
	Logger.info(`${NAME} > initLoadMoreButton`);

	if (!loadMoreButtonDom) return;

	// Set up an intersection observer to watch for the load more button
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// If the load more button is in view, load more posts
				loadMorePosts();
			}
		});
	}, {
		rootMargin: '0px 0px -100px 0px',
		threshold: 0.1
	});
	// Observe the load more button
	observer.observe(loadMoreButtonDom);

	loadMoreButtonDom.addEventListener('click', (event) => {
		event.preventDefault();
		loadMorePosts();
	});
};

/**
 * initMap - Initialize the PropertyMap partial
 */
const initMap = () => {
	Logger.info(`${NAME} > initMap`);

	if (!propertyMapDom) return;

	const el = new PropertyMap(propertyMapDom);
	el.init();
};

/**
 * loadMorePosts - Load more posts
 */
const loadMorePosts = async () => {
	Logger.info(`${NAME} > loadMorePosts`);

	if (!propertyGridDom) return;

	currentPaginationPage++;

	let html = "";

	// Make a WordPress Ajax request to load more posts
	let _data = {
		action: "wonder_load_more_current_properties",
		nonce: window.global_vars.ajax_nonce,
		paged: currentPaginationPage,
		keywords: document.querySelector(`#keywords`).value,
		property_type: document.querySelector(`#property-type`).value,
		city: document.querySelector(`#city`).value,
		region: document.querySelector(`#region`).value,
		sort_option: document.querySelector(`#sort_option`).value,
		sort_order: document.querySelector(`#sort_order`).value,
	};

	// Make the request
	let response = await fetch(window.global_vars.ajax_url, {
		method: "POST",
		body: new URLSearchParams(_data).toString(),
		headers: { "Content-type": "application/x-www-form-urlencoded" },
	});
	let data = await response.json();

	if (data.success && data.data.html) {
		html = data.data.html;
	}

	// If no posts were returned, stop
	if (html === "") {
		// Hide the load more button
		loadMoreButtonDom.style.display = "none";
	}

	// Append the new posts to the container
	propertyGridDom.insertAdjacentHTML("beforeend", html);
};

/**
 * toggleFilterDrawer - Toggle the filter drawer
 */
const toggleFilterDrawer = () => {
	Logger.info(`${NAME} > toggleFilterDrawer`);

	if (!filterDrawerDom) return;

	filterDrawerDom.classList.toggle(filterDrawerActiveClass);
};

/**
 * toggleSortDrawer - Toggle the sort drawer
 */
const toggleSortDrawer = () => {
	Logger.info(`${NAME} > toggleSortDrawer`);

	if (!sortDrawerDom) return;

	sortDrawerDom.classList.toggle(sortDrawerActiveClass);
};

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
